import { OrganizationAction,ADD_ORGANIZATION} from "./types";

export function addNameOrganization(nameOrganization: string): OrganizationAction {
    return {
        type: ADD_ORGANIZATION,
        payload: nameOrganization
    }
  }